import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import styles from "./App.module.scss";
import Header from "./components/header/Header.component";
import Footer from "./components/Footer/Footer.component";
import SearchBar from "./components/searchBar/SearchBar.component";
import { Group } from "@mantine/core";
import SectionTitle from "./components/SectionTitle/SectionTitle.component";
import CookiesBanner from "./components/CookiesBanner/CookiesBanner.component";
import ScrollToTop from "./utils/scrollToTop.component";
declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "flare-space-menu": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
    interface IntrinsicElements {
      "promo-banner": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

// //Example for props
// interface PersonInfoProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
//   heading: string,
//   subHeading: string,
//   size?: string
// }
function App() {
  const location = useLocation();
  const { pathname } = location;
  return (
    <div>
      <ScrollToTop />
      <Header></Header>
      <div className={styles.AppContent}>
        <SectionTitle></SectionTitle>
        {!pathname.includes("/validators") && (
          <Group justify={"center"} mb={{ sm: "3rem", lg: "5rem" }}>
            <SearchBar></SearchBar>
          </Group>
        )}
        <Outlet />
      </div>
      <Footer></Footer>
      <CookiesBanner />
    </div>
  );
}

export default App;
